import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2631f3da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"padding-bottom":"20px"}
}
const _hoisted_2 = { class: "ant-upload-drag-icon" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "点击或将文件拖拽此处上传", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-hint" }, null, -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "show-box" }

import { computed, ref } from 'vue';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { ScForm } from '@/models/ScForm';
import { UploadChangeParam, UploadProps } from 'ant-design-vue';
import config from '@/config';
import { tokenManager } from '@/util/token';
import { FileFieldType } from '@/components/business/crud/interface/FieldType';


import { definedWidgetMeta } from '@/components/business/crud/widgets/widgetManager';

export const meta = definedWidgetMeta({
  size: { edit: 'large', show: 'small' },
});

export default /*#__PURE__*/_defineComponent({
  __name: 'FileForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

const uploadPath = config.uploadApiPath;
const uploadList = ref<Exclude<UploadProps['fileList'], undefined>>([]);
const headers = {
  ...tokenManager.get(),
};

const fileList = computed(() => {
  const res: Exclude<UploadProps['fileList'], undefined> = (
    data.value[props.propName]?.split(',') || []
  )
    .filter((i) => i)
    .map((item) => {
      return {
        uid: item,
        name: item,
        status: 'done',
        url: config.uploadPath + item,
      };
    });
  return res.concat(...uploadList.value);
});

function onChange(info: UploadChangeParam) {
  uploadList.value = info.fileList.filter((file) => file.status !== 'done');
  const file = info.file;
  if (file.status === 'removed') {
    data.value[props.propName] = (data.value[props.propName]?.split(',') || [])
      .filter((i) => i)
      .filter((id: string) => id !== file.uid)
      .join(',');
  } else if (file.status === 'done') {
    data.value[props.propName] = [
      ...(data.value[props.propName]?.split(',') || []),
      file.response.data.path,
    ].join(',');
  }
}

const files = computed(() => {
  return (data.value[props.propName]?.split(',') || [])
    .filter((i) => i)
    .map((i) => config.uploadPath + i);
});

function open(file: string) {
  window.open(file, '_blank');
}

return (_ctx: any,_cache: any) => {
  const _component_sc_icon = _resolveComponent("sc-icon")!
  const _component_a_upload_dragger = _resolveComponent("a-upload-dragger")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_ctx.info.status === 'edit')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_upload_dragger, {
          action: _unref(uploadPath),
          "file-list": fileList.value,
          headers: headers,
          onChange: onChange,
          multiple: _ctx.widget.multi
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, [
              _createVNode(_component_sc_icon, { type: "InboxOutlined" })
            ]),
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }, 8, ["action", "file-list", "multiple"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
            return (_openBlock(), _createBlock(_component_a_tooltip, {
              title: file,
              key: index
            }, {
              default: _withCtx(() => [
                _createVNode(_component_sc_icon, {
                  type: "FileTextOutlined",
                  style: {"color":"#1da57a","font-size":"50px"},
                  onClick: ($event: any) => (open(file))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["title"]))
          }), 128))
        ])
      ]))
}
}

})